module.exports = __webpack_public_path__ + "static/haulmont-f3d80901a2bdc50e8773946c57a3b728.svg";